import React, { useState } from "react";
import CBCForm from "../Pages/CBCForm";
import BiochemistryForm from "../Pages/BiochemistryForm";
import SerologyForm from "../Pages/SerologyForm";
import Header from "../Pages/Header";
import UrineForm from "../Pages/UrineForm";
import TSHForm from "../Pages/TSHForm";
import LipidProfileForm from "../Pages/LipidProfileForm";
import DengueForm from "../Pages/DenguForm";
import IGGIGMForm from "../Pages/IGGIgmForm";
import SugarSGPTForm from "../Pages/SugarSGPTForm";
import MpWidalEsrForm from "../Pages/MpWidalEsrForm";
import BilirubinCalciumForm from "../Pages/BilirubinCalciumForm";
import UrineRMForm from "../Pages/UrineRMForm";

export default function Home() {
  const [selectedForm, setSelectedForm] = useState("CBC");

  const renderForm = () => {
    switch (selectedForm) {
      case "CBC":
        return <CBCForm />;
      case "Biochemistry":
        return <BiochemistryForm />;
      case "Serology":
        return <SerologyForm />;
      case "Urine":
        return <UrineForm />;
      case "TSH":
        return <TSHForm />;
      case "Lipid Profile":
        return <LipidProfileForm />;
      case "Dengue":
        return <DengueForm />;
      case "IGG IGM":
        return <IGGIGMForm />;
      case "Sugar SGPT":
        return <SugarSGPTForm />;
      case "Mp WidalEsr":
        return <MpWidalEsrForm />;
      case "Bilirubin Calcium":
        return <BilirubinCalciumForm />;
      case "Urine RM":
        return <UrineRMForm />;

      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <div className="container mt-4">
        <div className="mb-4">
          <label htmlFor="formSelector" className="form-label">
            Select Report Type:
          </label>
          <select
            id="formSelector"
            className="form-select"
            value={selectedForm}
            onChange={(e) => setSelectedForm(e.target.value)}
          >
            <option value="CBC">CBC</option>
            <option value="Biochemistry">Biochemistry</option>
            <option value="Serology">Serology</option>
            <option value="Urine">Urine</option>
            <option value="TSH">TSH</option>
            <option value="Lipid Profile">Lipid Profile</option>
            <option value="Dengue">Dengue</option>
            <option value="IGG IGM">IGG IGM</option>
            <option value="Sugar SGPT">Sugar SGPT</option>
            <option value="Mp WidalEsr">Mp WidalEsr</option>
            <option value="Bilirubin Calcium">Bilirubin Calcium</option>
            <option value="Urine RM"> Urine RM</option>
          </select>
        </div>

        <div className="my-4 border p-3 rounded bg-light">{renderForm()}</div>
      </div>
      <Header />
    </>
  );
}
